import type { HologramSimIds, SimInventorySegmentName, SimKey } from 'types/common';

export interface CustomCellRendererProps<TValue = any, TProps = any> {
  value: TValue;
  columnValue: SimKey | 'checkbox';
  customProps: TProps;
}
export type CustomCellRendererReturn = React.ReactNode;
export type CustomCellRenderer<TValue, TProps> = (
  props: CustomCellRendererProps<TValue, TProps>
) => CustomCellRendererReturn;

export interface SimCellRendererProps {
  simDetailBaseUrl: string;
  handleLinkClick: (url: string, value: any) => void;
  isHeader?: boolean;
  segmentName: SimInventorySegmentName;
}

export interface ColumnDef<TValue = any, TCustomRendererValue = any, TCustomRendererProps = any> {
  name: string;
  width: number;
  value: TValue;
  nullsHigher: boolean;
  rightAligned?: boolean;
  numeric?: boolean;
  renderer?: CustomCellRenderer<TCustomRendererValue, TCustomRendererProps>;
}

export type ColumnDefs<TKey = any, TValue = any> = Map<TKey, ColumnDef<TKey, TValue>>;

interface MaxWidth {
  width: number;
  measured: boolean;
}

export type MaxWidths = Record<SimKey | 'checkbox', MaxWidth>;
export type MeasureElement = (el: HTMLDivElement | null, value: SimKey | 'checkbox') => void;

export type OnCheckboxToggled = (checked: boolean, hologramSimId?: HologramSimIds) => void;
export type OnAllCheckboxToggled = (checked: boolean) => void;

export const PAGE_SIZE = 100 as const;
export const ROW_OVERSCAN = 10 as const;
export const COL_OVERSCAN = 4 as const;
export const ROW_HEIGHT = 41 as const; // 40px cell, 1px border
export const TABLE_CELL_PADDING = 32 as const;
